export default {"src":"/_next/static/media/TwitchGlitchWhite.026d13f3.svg","height":2800,"width":2400,"blurWidth":0,"blurHeight":0};